import { instance } from "apis/interceptor";
import * as Sentry from "@sentry/react";
import { THost, TRegisterMessengerChannel, TRegisterMessengerHost, TMessengerChannel } from "./type";
import { TMember } from "types/user.types";

type ResponseType<T> = {
  success: boolean;
  statusCode?: number;
  message?: string;
  data?: T;
};

export const getDoorBellInfo = async (
  deviceId: string
): Promise<{ receivers: TRegisterMessengerHost[]; channels: TRegisterMessengerChannel[] } | undefined> => {
  try {
    const res = await instance.post("/visitors/setting/device/doorbell", {
      id: deviceId,
    });
    return res.data;
  } catch (error) {
    Sentry.captureException(error, { extra: { id: deviceId } });
  }
};

export const updateDoorBellActive = async (deviceId: string, isDoorBellEnabled: boolean): Promise<boolean> => {
  try {
    const res = await instance.patch("/visitors/setting/device/doorbell", {
      id: deviceId,
      isDoorBellEnabled: isDoorBellEnabled,
    });
    return res.data.result;
  } catch (error) {
    Sentry.captureException(error, { extra: { id: deviceId, isDoorBellEnabled: isDoorBellEnabled } });
    return false;
  }
};

export const deleteDoorBellReceiver = async (receiverId: string): Promise<boolean> => {
  try {
    const res = await instance.delete("/visitors/setting/device/doorbell/host", {
      data: {
        id: receiverId,
      },
    });
    return res.data.result;
  } catch (error) {
    Sentry.captureException(error, { extra: { id: receiverId } });
    return false;
  }
};

//INFO: (new) Device별 초인종 수신자(DM) 등록하기
export const registerDoorBellReceiver = async (
  deviceId: string,
  memberList: TMember[]
): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.post("/visitors/setting/device/doorbell/host/receiver", {
      id: deviceId,
      memberList: memberList,
    });
    return { success: res.data.result };
  } catch (error) {
    Sentry.captureException(error, { extra: { id: deviceId, memberList: memberList } });
    return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
  }
};

//INFO: (new) Device별 초인종 채널 등록하기
export const registerDoorBellChannel = async (
  deviceId: string,
  messengerType: string,
  channelId?: string,
  channelName?: string
): Promise<boolean> => {
  try {
    const res = await instance.post("/visitors/setting/device/doorbell/host/channel", {
      id: deviceId,
      messengerType: messengerType,
      channelInfo: {
        channelId: channelId,
        channelName: channelName,
      },
    });
    return res.data.result;
  } catch (error) {
    return false;
  }
};
